"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIsDateExpired = void 0;
const checkIsDateExpired = (date) => {
    return new Date(date).valueOf() < Date.now();
};
exports.checkIsDateExpired = checkIsDateExpired;
